import React from 'react';
import { Button, Tooltip } from 'antd';
import { RobotOutlined } from '@ant-design/icons';
import { useAiChat } from '../viewmodels/AiChatProvider';
import { useAiChatActions } from '../viewmodels/useAiChatActions';
export default function AiChatHeaderButton() {
 const { store,state }=useAiChat(); const actions=useAiChatActions(); if (!store) return null;
 return <>{actions.holder}<Tooltip title="AI Assistant — open a docked chat" placement="bottom"><Button type="text" className={`app-header-icon-button ${state.dock?.open ? "is-active":""}`} aria-label="AI Assistant" aria-pressed={!!state.dock?.open} icon={<RobotOutlined />} onClick={() => { if (!state.dock?.open || state.dock.minimized) store.showDock(); else actions.closeDock(); }} /></Tooltip></>;
}

